/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_TitleInputs */

const zh_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用分析`)
};

const en_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage Analytics`)
};

const es_analytics_title = /** @type {(inputs: Analytics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de uso`)
};

/**
* | output |
* | --- |
* | "Usage Analytics" |
*
* @param {Analytics_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const analytics_title = /** @type {((inputs?: Analytics_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_title(inputs)
	if (locale === "en") return en_analytics_title(inputs)
	return es_analytics_title(inputs)
});